import React from 'react';
import { Avatar, Divider, Dropdown, Menu, Typography } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../store/user';
import { Flex } from 'rebass';
import { firebaseApp } from '../../../firebase';

export function UserMenu() {
  const user = useSelector(selectUser);
  const menu = (
    <Menu>
      <Menu.Item>
        <Flex py={2} flexDirection="column">
          <Typography.Text>Signed in as </Typography.Text>
          <Typography.Text strong>{user?.email}</Typography.Text>
        </Flex>
      </Menu.Item>
      <Divider style={{ margin: 0 }} />
      <Menu.Item danger>
        <Flex py={2} alignItems="center" onClick={() => firebaseApp.auth().signOut()}>
          <LogoutOutlined />
          <Typography.Text style={{ marginLeft: '10px', color: 'inherit' }}>Sign Out</Typography.Text>
        </Flex>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu}>
      <Avatar icon={<UserOutlined />} />
    </Dropdown>
  );
}
